import { Box, Tab, Tabs } from "@mui/material";
import { useContext, useState } from "react";
// import MedicalHistory from "./medicalHistory/MedicalHistory";
import FamilyHistory from "./FamilyHistory/FamilyHistory";
import SocialHistory from "./socialHistory/Socialhistory";
import MedicalHistory from "./medicalHistory/MedicalHistory";
import { HL7ContexTriggerContex } from "../../../context/HL7MessageTrigger/HL7MessageTriggerProvider";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
 
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const History = () => {
  const { triggerApi } = useContext(HL7ContexTriggerContex);
  const [value, setValue] = useState(0);
  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    if (newValue == 1 || newValue == 2) {
      triggerApi();
    }

    setValue(newValue);
  };

  return (
    <div >
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        aria-label="scrollable force tabs example"
      >
        <Tab label="Medical History" {...a11yProps(0)} />
        <Tab label="Family History" {...a11yProps(0)} />
        <Tab label="Social History" {...a11yProps(1)} />
      </Tabs>

      <CustomTabPanel value={value} index={0}>
        <MedicalHistory />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <FamilyHistory />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <SocialHistory />
      </CustomTabPanel>
    </div>
  );
};

export default History;
